import { render, staticRenderFns } from "./BindWallet.vue?vue&type=template&id=1bb4cca7&scoped=true"
import script from "./BindWallet.vue?vue&type=script&lang=js"
export * from "./BindWallet.vue?vue&type=script&lang=js"
import style0 from "./BindWallet.vue?vue&type=style&index=0&id=1bb4cca7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4cca7",
  null
  
)

export default component.exports